import { gql } from '@apollo/client';

export const UploadFile = gql`
    mutation uploadFile($file: Upload!, $agentId: ID!) {
        uploadFile(file: $file, agentId: $agentId) {
            ... on UploadedKnowledgeDataSuccessType {
                message
                knowledgeData {
                    id
                    source
                    active
                    sourceType
                    text
                    createdAt
                }
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
